import { ArtOrderOffer } from "@/api/art-order/types";
import { getDaysInSeconds } from "@/shared/dates";

function buildContractArtOrder(artOrderOffer: ArtOrderOffer) {
  return {
    nonce: artOrderOffer.order.nonce,
    orderer: artOrderOffer.order.author.address,
    artist: artOrderOffer.author.address,
    price: artOrderOffer.price,
    timeframe: getDaysInSeconds(artOrderOffer.timeframe),
    paymentErc20TokenAddress:
      artOrderOffer.order.budgetPaymentERC20TokenAddress,
  };
}

export { buildContractArtOrder };
